import React from 'react';

import type { Control, FieldValues } from 'react-hook-form';

import type { UseBooleanCallbacks } from '@/_shared';
import { noop } from '@/_shared';

import type { SubFormProps } from './types';

export type SubFormControlState<T extends FieldValues> = Record<string, Control<T>>;
export type SubFormLinkHandler<T extends FieldValues> = (id: string, subForm: Omit<SubFormProps<T>, 'id'>) => void;
export type SubFormUnlinkHandler = (id: string) => void;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type MainFormContextType<T extends FieldValues = any> = {
  isFormDirty: boolean;
  dirtySubFormIds: string[];
  isSubmitting: boolean;
  submitSubForm: UseBooleanCallbacks;
  linkSubForm: SubFormLinkHandler<T>;
  unlinkSubForm: SubFormUnlinkHandler;
  submitForm: () => void;
};

export const MainFormContext = React.createContext<MainFormContextType>({
  isFormDirty: false,
  dirtySubFormIds: [],
  isSubmitting: false,
  submitSubForm: { setTrue: noop, setFalse: noop, set: noop, toggle: noop },
  linkSubForm: noop,
  unlinkSubForm: noop,
  submitForm: noop,
});

export const MainFormProvider = MainFormContext.Provider;

export const useMainFormContext = () => {
  const context = React.use(MainFormContext);

  return context;
};
